import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  NavLink,
  Image,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditRegistry = ({ registryId, editRegistryCancelBtnClick }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [registry, setRegistry] = useState({});
  const [formData, setFormData] = useState({}); // Initialize formData state
  useEffect(() => {
    axios
      .get(
        `https://wiser-ai.expertvillagemedia.com/api/editregistry/${registryId}`
      )
      .then((res) => {
        //console.log("res.data");
        //console.log(res.data);
        //return false;
        setRegistry(res.data.data);
        setFormData(res.data.data); // Set formData with registry data
      });
  }, [registryId]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const config = {
    headers: {
      //Authorization:`Bearer ${userInfo.token}`
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        `https://wiser-ai.expertvillagemedia.com/api/updateregistry`,
        formData,
        config
      )
      .then((response) => {
        // Handle the response or redirect to another page
        console.log("Registry updated successfully:", response.data);

        toast("Giftregistry updated successfully.!");
        //window.location='./pages/evmnew';
        //alert('Registry updated successfully');
        // You can redirect the user to another page or show a success message
      })
      .catch((error) => {
        // Handle errors
        console.error("Error updating registry:", error);
        // You can show an error message to the user
      });
  };

  return (
    <div className="evm_gift-manage-regi_modal">
      <div className="evm_giftregistry_cancel">
        <Link to="#" onClick={editRegistryCancelBtnClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
          >
            <path
              d="M19 19L23.4793 23.4793M19 19L14.5223 23.4793M19 19L23.4793 14.5223M19 19L14.5223 14.5223"
              stroke="#8780A0"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 34.8333C27.7448 34.8333 34.8333 27.7447 34.8333 19C34.8333 10.2552 27.7448 3.16663 19 3.16663C10.2553 3.16663 3.16667 10.2552 3.16667 19C3.16667 27.7447 10.2553 34.8333 19 34.8333Z"
              stroke="#8780A0"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </Link>{" "}
      </div>
      <form className="giftregsubmitform" onSubmit={handleSubmit}>
        <div className="giftregform">
          <h4>Registry Profile</h4>
          <div className="form-fields">
            <div className="form-control  ">
              <label>Registry title *</label>
              <input
                type="hidden"
                name="customer_id"
                value={window.Shopline.customer.id}
              />
              <input type="hidden" name="id" value={registryId} />
              <input
                type="text"
                name="regtitle"
                value={formData.regtitle || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Event date *</label>
              {/* <input type='date' name='regdate' value={formData.regdate || ''} onChange={handleChange} /> */}
              <input
                type="date"
                name="regdate"
                value={formData.regdate || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Public message to Friends and family *</label>
              <input
                type="text"
                name="regmessage"
                value={formData.regmessage || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Add aditional info</label>
              <input
                type="text"
                name="regaddinfo"
                value={formData.regaddinfo || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Type of event</label>
              <select
                name="regtype"
                value={formData.regtype || ""}
                onChange={handleChange}
              >
                <option value="Baby">Baby</option>
                <option value="Birthday">Birthday</option>
                <option value="Wedding">Wedding</option>
                <option value="Christmas">Christmas</option>
                <option value="Holiday">Holiday</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>

        <div className="giftregform">
          <h4>Registrant Information</h4>
          <div className="form-fields  ">
            <div className="form-control">
              <label>Title *</label>
              <input
                type="text"
                name="r_title"
                value={formData.r_title || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>First name *</label>
              <input
                type="text"
                name="r_fname"
                value={formData.r_fname || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>last name *</label>
              <input
                type="text"
                name="r_lname"
                value={formData.r_lname || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Email *</label>
              <input
                type="email"
                name="r_email"
                value={formData.r_email || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Phone *</label>
              <input
                type="tel"
                name="r_phone"
                value={formData.r_phone || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="giftregform">
          <h4>Shipping Information</h4>
          <div className="form-fields  ">
            <div className="form-control">
              <label>Address *</label>
              <input
                type="text"
                name="r_address"
                value={formData.r_address || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>City *</label>
              <input
                type="text"
                name="r_city"
                value={formData.r_city || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>State *</label>
              <input
                type="text"
                name="r_state"
                value={formData.r_state || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Country *</label>
              <input
                type="text"
                name="r_country"
                value={formData.r_country || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-control  ">
              <label>Zip/Postal Code *</label>
              <input
                type="text"
                name="r_zip"
                value={formData.r_zip || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="giftregform">
          <div className="form-control  ">
            <input
              type="submit"
              name="r_submit"
              className="submit-rgstry"
              value="Update My Registry"
            />
          </div>

          {/* <div className='form-control  '>
              <Link className='submit-rgstry' to="/pages/evmnew">Cancel</Link>                
            </div> */}
          <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
          />
        </div>
      </form>
    </div>
  );
};

export default EditRegistry;
